import { OrderCardHeader as KyokoOrderCardHeader } from '@talos/kyoko';

type OrderCardHeaderProps = React.ComponentProps<typeof KyokoOrderCardHeader>;

export const OrderCardHeader = (props: OrderCardHeaderProps) => {
  return <KyokoOrderCardHeader {...props} />;
};
